import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosRequestConfig } from 'axios';

import { apiEndpoint } from 'config/track-config';
import { CollectionPointData } from 'models/CollectionPoint';
import { AppAsyncThunkOpts } from 'models/Store';
import axiosInstance from 'utils/axios.utils';

export const getlocationsWorkCentre = createAsyncThunk<CollectionPointData | null, string, AppAsyncThunkOpts>(
  'location/getlocationsWorkCentre',
  async (wcid, thunkAPI) => {
    try {
      const workCentre = await apiGetlocationsWorkCentre(wcid);
      const workCentreInfo = workCentre.data.points?.[0] ?? null;
      if (!workCentreInfo) return null;
      const { name, type, address, hours, service_codes } = workCentreInfo;

      const workCentreData: CollectionPointData = {
        name,
        type,
        address,
        hours,
        service_codes,
      };
      return workCentreData;
    } catch (err) {
      const axiosErr = err as AxiosError;
      if (axiosErr.isAxiosError) {
        return thunkAPI.rejectWithValue({
          status: axiosErr.response?.status,
          data: axiosErr.response?.data,
          isAxiosError: axiosErr.isAxiosError,
        });
      }
      throw err;
    }
  }
);

const apiGetlocationsWorkCentre = (wcid: string) => {
  const _locationWorkCentreUrl = `${apiEndpoint.locationWorkCentre}/${wcid}`;
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'AUTH-KEY': apiEndpoint.apiKeys.locationsAPI,
    },
    params: {
      types: 'PO,UPL,DC',
    },
  };
  const response = axiosInstance.get(_locationWorkCentreUrl, requestConfig);
  return response;
};
